import env from './env';
import platform from './platform';
import tool from './tool';
import { Base64 } from 'js-base64';
export default {
  env,
  platform,
  tool,
  Base64,
};
